// Admin marketplace-home-page curation API client.
//
// Backed by:
//   GET  /api/admin/home-page          → current hero + featured list
//   PUT  /api/admin/home-page/hero     → set/clear hero (singleton)
// The "featured projects" toggle uses the pre-existing
// PUT /api/admin/projects/:id/featured (adminProjectsApi.setProjectFeatured).
import { request } from "../base";

export type HomePageProjectSummary = {
	id: string;
	title: string;
	slug: string | null;
	status: string;
	coverImage: string | null;
	proId: string;
	isFeatured: boolean;
	isHero: boolean;
};

export type HomePageCuration = {
	hero: HomePageProjectSummary | null;
	featured: HomePageProjectSummary[];
};

export const adminHomePageApi = {
	async getHomePageCuration() {
		return request<HomePageCuration>(`/api/admin/home-page`);
	},

	async setHero(projectId: string | null) {
		return request<{ hero: HomePageProjectSummary | null }>(
			`/api/admin/home-page/hero`,
			{
				method: "PUT",
				body: { projectId },
			},
		);
	},
};
